// extracted by mini-css-extract-plugin
export var anticlockwise = "cg_kH";
export var svg = "cg_kF";
export var wrapper = "cg_F";
export var wrapperFlexCenter = "cg_kG";